import ThumbnailImage, { ThumbnailImageInit } from './ThumbnailImage';

export interface StaffInit {
  id: number;
  publicId: number;
  name: string;
  image?: ThumbnailImageInit;
  description: string;
}

export default class Staff {
  public readonly id: number;
  public readonly publicId: number;
  public readonly name: string;
  public readonly image?: ThumbnailImage;
  public readonly description: string;

  constructor(init: StaffInit) {
    this.id = init.id;
    this.publicId = init.publicId;
    this.name = init.name;
    this.image = init.image ? new ThumbnailImage(init.image) : undefined;
    this.description = init.description;
  }
}
